import React, { useState, useEffect } from "react";
import pulplogonew from "../img/pulplitlogo.svg";
import bgContact from "../img/bgContact.avif";
import contactpump from "../img/contact.avifs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact() {
  const [showOverlay, setShowOverlay] = useState(false);

  // Calendly Widget Yükleme
  useEffect(() => {
    if (showOverlay) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showOverlay]);

  return (
    <div
      id="contact"
      className="relative w-full mobile:bg-pulpContact mobile:h-[50vh] h-screen md:h-[55vh] lg:h-screen flex items-center bg-white justify-center"
    >
      <img
        src={contactpump}
        alt="GIF"
        className="absolute right-0 mobile:mt-[-20px] top-0 mobile: w-full h-full mobile:object-contain object-fill transition-opacity duration-1000"
      />

      <button
        className="absolute mobile:mt-[15vh] mobile:left-[15vw] left-[10vw] mt-[10vh] md:left-[20vw] md:mt-[25vh] lg:mt-[50vh] cursor-pointer font-semibold rounded-full bg-orange-400 hover:bg-orange-500 text-white py-2 text-base md:text-xl 2xl:text-2xl px-5"
        onClick={() => setShowOverlay(true)}
      >
        PULP IT
      </button>
      <p className="absolute mobile:mt-[30vh] mobile:left-[10vw] left-[10vw] mt-[25vh] text-white md:left-[20vw] md:mt-[40vh] lg:mt-[75vh] tablet:w-2/4 lg:w-2/4 2xl:w-1/3 text-xs md:text-base">
        Pulp, the award-winning Growth Architecture agency built where bold
        ideas turn into compounding growth.
      </p>

      <img
        src={bgContact}
        alt="GIF"
        className={`absolute inset-0 w-full h-full mobile:object-cover mobile:object-left lg:object-fill xl:object-fill 2xl:object-cover transition-opacity duration-1000 ${
          showOverlay ? "opacity-100 block" : "opacity-0 hidden"
        }`}
      />
      <div
        className={`absolute mobile:scale-50 container h-full p-4 ml-auto mr-auto flex flex-col md:flex-row justify-center md:justify-between items-center transition-opacity duration-1000 ${
          showOverlay ? "opacity-100 block" : "opacity-0 hidden"
        }`}
      >
        <div className="mo text-white text-center mb-8 md:mb-0 md:mr-10 md:w-1/2">
          <h2 className="text-5xl text-left flex justify-center text-black font-bold">
            PULP IT
          </h2>
          <div className="flex justify-center mt-10">
            <img src={pulplogonew} alt="" />
          </div>
        </div>

        <div className="w-full md:w-1/2 flex items-center justify-center">
          <div className="max-w-md w-full bg-opacity-100 p-0 lg-p- mobile:p-0 min-h-[250px] rounded-lg min-w-full lg-min-h-full bg-white tablet:scale-75 ">
            {showOverlay && (
              <div
                className="calendly-inline-widget min-h-[250px] p-0  "
                data-url="https://calendly.com/c-kestir-pulpmedia/growth-roadmap-session"
                style={{
                  minwidth: "320px",
                  display: "flex",
                  height: "100vh",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: "10px",
                }}
              ></div>
            )}
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default Contact;
